import React from 'react';

interface Props {
  title: string;
  count: number;
  className?: string;
}
const DashboardCard = ({ title, count, className }: Props) => {
  return (
      <div
        className={`border ${className} py-2 px-3 rounded-[10px] min-w-[150px] max-w-[200px] text-center`}
      >
        <div className="text-3xl font-extrabold">{count}</div>
        <div className="text-xs font-medium uppercase tracking-wider mt-1">{title}</div>
      </div>
  );
};

export default DashboardCard;
